import { PROBLEMS } from "./data";
import { Reveal, Overline } from "./primitives";

export const Problem = () => {
  return (
    <section
      id="problem"
      data-testid="problem-section"
      className="relative overflow-hidden bg-slate-50 py-24 sm:py-32"
    >
      <div className="absolute inset-0 pm-grid opacity-60" />
      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-3xl">
          <Reveal>
            <Overline>The Challenge</Overline>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-5 font-heading text-4xl font-bold leading-[1.06] tracking-tight text-slate-900 sm:text-5xl">
              Traditional Pipeline Planning Falls Short
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 text-lg leading-relaxed text-slate-600">
              Agricultural pipelines are often planned using manual measurements
              and practical experience with limited engineering calculations.
              That gap can quietly create costly problems.
            </p>
          </Reveal>
        </div>

        <div className="mt-14 grid gap-5 md:grid-cols-6">
          {PROBLEMS.map((p, i) => {
            // bento: first two span 3 cols, rest span 2
            const span = i < 2 ? "md:col-span-3" : "md:col-span-2";
            return (
              <Reveal key={p.title} delay={i * 0.07} className={span}>
                <div className="group h-full rounded-3xl border border-slate-200 bg-white p-7 transition-all duration-300 hover:-translate-y-1.5 hover:border-[#1a6fc4]/25 hover:shadow-lg">
                  <div className="flex items-start justify-between">
                    <div className="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-[#fdecec] text-[#d9534f] transition-colors duration-300 group-hover:bg-[#1a6fc4]/10 group-hover:text-[#1a6fc4]">
                      <p.icon className="h-6 w-6" strokeWidth={1.7} />
                    </div>
                    <span className="font-mono text-sm text-slate-300">
                      0{i + 1}
                    </span>
                  </div>
                  <h3 className="mt-6 font-heading text-xl font-bold tracking-tight text-slate-900">
                    {p.title}
                  </h3>
                  <p className="mt-3 text-[15px] leading-relaxed text-slate-600">
                    {p.desc}
                  </p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
